import * as e from "react";
import a from "../lib/SSRBase.es.js";
import c from "../defs/ChatCircle.es.js";
const r = e.forwardRef((t, o) => /* @__PURE__ */ e.createElement(a, { ref: o, ...t, weights: c }));
r.displayName = "ChatCircleIcon";
const s = r;
export {
  s as ChatCircle,
  r as ChatCircleIcon
};
